import { Routes } from '@angular/router';

import { ERoutes, UtilityRoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const workIndustryRoutes: Routes = [
  {
    path: ERoutes.WORK_INDUSTRY,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./work-industry-table/work-industry-table.component').then(
            (m) => m.WorkIndustryTableComponent
          ),
      },
      {
        path: UtilityRoutes.CARD,
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./work-industry-card/work-industry-card.component').then(
            (m) => m.WorkIndustryCardComponent
          ),
      },
    ],
  },
];
